import React from 'react';
import { FadeIn } from './FadeIn';
export function ProblemSection() {
  return <section className="py-24 px-6 bg-cream" data-id="element-125">
      <div className="max-w-4xl mx-auto" data-id="element-126">
        <div className="flex flex-col md:flex-row gap-12 items-start" data-id="element-127">
          <div className="md:w-1/3" data-id="element-128">
            <FadeIn direction="right" data-id="element-129">
              <div className="sticky top-12" data-id="element-130">
                <h3 className="text-sm font-bold tracking-widest uppercase text-terracotta mb-4" data-id="element-131">
                  El problema real
                </h3>
                <div className="w-12 h-1 bg-terracotta/30 rounded-full mb-6" data-id="element-132"></div>
                <p className="text-brown-light text-lg font-serif italic" data-id="element-133">
                  No es solo dolor, es la pérdida de tu independencia diaria.
                </p>
              </div>
            </FadeIn>
          </div>

          <div className="md:w-2/3" data-id="element-134">
            <FadeIn delay={0.2} data-id="element-135">
              <div className="bg-white/60 backdrop-blur-sm p-8 sm:p-10 rounded-2xl shadow-sm border border-cream-light" data-id="element-136">
                <p className="text-lg sm:text-xl text-brown leading-relaxed mb-6" data-id="element-137">
                  El dolor articular no solo es incómodo, es limitante. Tareas
                  sencillas como bajar escaleras, abrir un frasco o incluso
                  caminar en la casa pueden convertirse en un reto diario.
                </p>
                <p className="text-lg sm:text-xl text-brown leading-relaxed" data-id="element-138">
                  Y lo peor es que muchos tratamientos solo ofrecen un alivio
                  temporal. Te has sentido atrapada en un ciclo de dolor y
                  frustración.
                </p>
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}